/* Limitless Deals Daily variant tray — draft theme only, Oct 25 2026.
   A tray tap clicks the matching radio in the theme's own variant picker,
   so gallery, price, sticky bar and URL all update through existing logic.
   The tray never sets variant state itself. */
(function () {
  function init() {
    var tray = document.querySelector('[data-ldd-variant-tray]');
    if (!tray) return;

    var picker = document.querySelector('variant-picker');
    if (!picker) return;

    var buttons = tray.querySelectorAll('[data-ldd-variant-id]');
    var wired = false;

    buttons.forEach(function (button) {
      var input = picker.querySelector('input[data-variant-id="' + button.dataset.lddVariantId + '"]');
      if (!input) return;
      wired = true;

      button.addEventListener('click', function () {
        if (button.disabled) return;
        input.click();
      });
    });

    if (!wired) return;
    document.body.classList.add('ldd-tray-active');

    var label = tray.querySelector('[data-ldd-selected-name]');
    function sync() {
      var checked = picker.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      var variantId = checked.dataset.variantId;
      buttons.forEach(function (button) {
        var selected = button.dataset.lddVariantId === variantId;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (selected && label) label.textContent = button.dataset.lddVariantTitle;
      });
    }

    picker.addEventListener('change', sync);
    sync();

    /* Stuck strip (Oct 25 evening, Taylor's follow request): a compact copy
       of the tray, fixed under the header once the original tray scrolls
       away. The original tray stays in place, so there is no layout jump.
       The strip follows the shopper through the product details and is
       removed once the product section ends (before recommendations), so it
       follows "a little further" instead of chasing them down the page. */
    var strip = document.createElement('div');
    strip.className = 'ldd-variant-tray ldd-variant-tray--stuck';
    strip.setAttribute('aria-hidden', 'true');
    var stripLabel = document.createElement('p');
    stripLabel.className = 'ldd-variant-tray__label';
    stripLabel.innerHTML = tray.querySelector('.ldd-variant-tray__label').innerHTML;
    var stripRow = document.createElement('div');
    stripRow.className = 'ldd-variant-tray__row';
    strip.appendChild(stripLabel);
    strip.appendChild(stripRow);
    document.body.appendChild(strip);

    var stripButtons = [];
    buttons.forEach(function (button) {
      var clone = button.cloneNode(true);
      clone.addEventListener('click', function () {
        if (button.disabled) return;
        button.click();
      });
      stripRow.appendChild(clone);
      stripButtons.push(clone);
    });

    function syncStrip() {
      var checked = picker.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      stripButtons.forEach(function (clone, i) {
        var selected = clone.dataset.lddVariantId === checked.dataset.variantId;
        clone.classList.toggle('is-selected', selected);
        clone.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (selected) stripLabel.querySelector('[data-ldd-selected-name]').textContent = buttons[i].dataset.lddVariantTitle;
      });
    }
    picker.addEventListener('change', syncStrip);
    syncStrip();

    var productSection = tray.closest('.shopify-section');
    var trayAboveViewport = false;
    function headerOffset() {
      var header = document.querySelector('#header-component, .header-section');
      if (!header) return 0;
      var rect = header.getBoundingClientRect();
      return rect.bottom > 0 ? Math.max(0, rect.bottom) : 0;
    }
    function updateStrip() {
      if (!trayAboveViewport) {
        strip.classList.remove('is-visible');
        return;
      }
      if (productSection) {
        var sectionRect = productSection.getBoundingClientRect();
        if (sectionRect.bottom < headerOffset() + 80) {
          strip.classList.remove('is-visible');
          return;
        }
      }
      strip.style.top = headerOffset() + 'px';
      strip.classList.add('is-visible');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        trayAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateStrip();
      }).observe(tray);
    }
    var rafPending = false;
    window.addEventListener(
      'scroll',
      function () {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () {
          rafPending = false;
          updateStrip();
        });
      },
      { passive: true }
    );
    window.addEventListener('resize', updateStrip);

    /* Preload the full-size variant images after the page settles, so a
       tray tap swaps the main photo instantly instead of fetching it then. */
    var preload = document.querySelector('[data-ldd-variant-images]');
    if (preload && 'requestIdleCallback' in window) {
      requestIdleCallback(function () {
        try {
          JSON.parse(preload.textContent || '[]').forEach(function (src) {
            var img = new Image();
            img.src = src;
          });
        } catch (e) {
          /* Preload is a nicety only; a failure must not affect picking. */
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
